import { render, staticRenderFns } from "./Web.vue?vue&type=template&id=285e3193&scoped=true&lang=pug&"
import script from "./Web.vue?vue&type=script&lang=ts&"
export * from "./Web.vue?vue&type=script&lang=ts&"
import style0 from "./Web.vue?vue&type=style&index=0&id=285e3193&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e3193",
  null
  
)

export default component.exports